import { createApp } from 'vue';
import { VueFire, VueFireAuth } from 'vuefire';
import { createPinia } from 'pinia';
import { firebaseApp } from './firebase/app';
import { registerSW } from 'virtual:pwa-register'
import App from './app/App.vue';
import router from './app/router/app-router';
import DefaultLayout from './app/layouts/DefaultLayout.vue';
import LoginLayout from './app/layouts/LoginLayout.vue';
import EventManagementLayout from './event/event/layouts/EventManagementLayout.vue';
import ManagementLayout from './app/layouts/ManagementLayout.vue';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../scss/custom.scss';
import './app/assets/styles.css';

registerSW({ immediate: true });

const app = createApp(App);
app.use(createPinia());
app.use(VueFire, {
  firebaseApp,
  modules: [VueFireAuth()],
});
app.use(router);
app.component('DefaultLayout', DefaultLayout);
app.component('LoginLayout', LoginLayout);
app.component('EventManagementLayout', EventManagementLayout);
app.component('ManagementLayout', ManagementLayout);
app.mount('#app');
